export const PROFILE_CITIZENSHIP_ERROR = 'PROFILE_CITIZENSHIP_ERROR';
export const PROFILE_CITIZENSHIP_LOADING = 'PROFILE_CITIZENSHIP_LOADING';
export const PROFILE_CITIZENSHIP_SUCCESS = 'PROFILE_CITIZENSHIP_SUCCESS';